<template>
    <Dialog v-model:visible="showDialog" :modal="true" :header="t('assetManagement.common.subassetMapping')"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '70vw' }" @after-hide="closeTrigger()">
        <SubAssetMappingComponents v-if="showDialog" v-model:selected-item="selectedItem" :EntityId="11"
            @close="closeTrigger()" />

    </Dialog>

</template>

<script lang="ts">
import { defineComponent, ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import TextInput from "../../../../../../../../components/FormComponents/TextInput.vue";
import CustomDropDown from "../../../../../../../../components/FormComponents/Dropdown.vue";
import CustomDatePicker from "../../../../../../../../components/FormComponents/DatePicker.vue";
import { ScanItemModel, AgreementList } from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/AssetInitialSetup/scanItemModel";
import SubAssetMappingComponents from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/components/subAssetMappingComponents.vue"

export default defineComponent({
    name: 'SubAsset',
    components: {
        SubAssetMappingComponents,
        TextInput,
        CustomDropDown,
        CustomDatePicker,
    },
    props: {
        // modelValue: {
        //     type: Array,
        //     required: true
        // },
        showDialog: {
            type: Boolean,
            default: ref(false),
        },
        convertiontype: {
            type: Number,
            default: 0

        },


        selectedItem: {
            type: Object,
            Default: () => { },
        },
        // showButton: {
        //     type: Boolean,
        //     Required: true,
        // },
        // OperationID: {
        //     type: Object,
        //     default: {},
        // },
        // EntityId: {
        //     type: Number,
        //     default: 0
        // }
    },
    emits: ['update:modelValue', 'close'],
    setup(props, { emit }) {
        const { t } = useI18n();
        // let localAgreementsData = <AgreementList[]>([...props.modelValue]);
        const model: any = ref(props.selectedItem);

        // watch(() => props.modelValue, (newValue) => {
        //     localAgreementsData = <AgreementList[]>[...newValue];
        // });

        const updateAgreement = (index: number) => {
            // emit('update:modelValue', localAgreementsData);
        };
        const assetItems = ref(props.selectedItem);
        function closeTrigger() {
            // alert('s')
            emit("close");
        }


        return {
            closeTrigger,
            model,
            t,
            // localAgreementsData,
            assetItems,
            updateAgreement,
        };
    }
});
</script>

<style scoped lang='scss'>
.asset-agreement-details {
    background-color: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 20px;
}

.agreement-section {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e1e1e1;
}

.agreement-section:last-child {
    border-bottom: none;
}

h4 {
    margin-bottom: 20px;
    color: #333;
}
</style>